import { render } from "./WarehouseGeneral.vue?vue&type=template&id=65b15601"
import script from "./WarehouseGeneral.vue?vue&type=script&lang=js"
export * from "./WarehouseGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__